import styled from 'styled-components';

const Container = styled.div`
  opacity: 0;
  -moz-transition: opacity 0.8s ease-in-out;
  -o-transition: opacity 0.8s ease-in-out;
  -webkit-transition: opacity 0.8s ease-in-out;
  transition: opacity 0.8s ease-in-out;

  &:before {
    content: ' ';
    position: absolute;
    top: -12px;
    right: 15px;
    height: 0px;
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    border-bottom: 13px solid var(--blue-5);
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5 {
    color: white;
  }

  .wistia-popover-cta--button {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-end;
  }

  @media (max-width: 576px) {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: 20px;
    }

    p {
      font-size: 16px;
    }

    .wistia-popover-cta--button {
      align-items: center;

      button {
        padding: 13px 17px;
        margin-top: 10px;
      }
    }
  }
`;

export { Container };
